import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';
import { useBulkDeployModalContext, BULK_DEPLOY_MODALS } from 'ion-experimental/app/bulk-deploy/BulkDeployModalContext';

/**
 * Hook to provide props for the BulkDeployTable ReactDataTable component
 */
export default function useBulkDeployTable() {
  const {
    pipelines,
    loadingPipelines,
    handleSelectAll,
    setSelectedPipelineIds,
    clearSelectedKey,
    onSort,
    onlyShowSelected,
    selectedPipelineIds,
  } = useBulkDeployPageContext();
  const { onOpenModal } = useBulkDeployModalContext();

  // Row click handler to open diff modal
  const handleRowClick = row => {
    onOpenModal(BULK_DEPLOY_MODALS.PIPELINE_DIFF, row);
  };

  // Selection change handler - wires ReactDataTable selection to context state
  const handleSelectedRowsChange = ({ allSelected, selectedCount, selectedRows }) => {
    if (allSelected) {
      handleSelectAll(true);
    } else if (selectedCount === 0) {
      handleSelectAll(false);
    } else {
      // Handle partial selection - update Set with selectedRows
      const selectedIds = new Set(selectedRows.map(row => row.id));
      setSelectedPipelineIds(selectedIds);
    }
  };

  const selectableRowDisabled = row => row.deploymentStatus.status === 'success';
  // Sam | I'd expect react-data-table to handle this internally but it doesn't seem to
  const data =
    onlyShowSelected && selectedPipelineIds.size > 0
      ? pipelines.filter(pipeline => selectedPipelineIds.has(pipeline.id))
      : pipelines;

  return {
    data,
    loading: loadingPipelines,
    progressPending: loadingPipelines,

    // Selection
    selectableRows: true,
    selectableRowsHighlight: true,
    selectableRowsVisibleOnly: onlyShowSelected,
    noContextMenu: true,
    onSelectedRowsChange: handleSelectedRowsChange,
    clearSelectedRows: clearSelectedKey,

    // Row events
    selectableRowDisabled,
    onRowClicked: handleRowClick,
    pointerOnHover: true,
    onSort,

    // Pagination
    pagination: true,
    paginationPerPage: 20,
    paginationRowsPerPageOptions: [5, 10, 20],
    paginationComponentOptions: {
      noRowsPerPage: false,
      rowsPerPageText: 'Rows per page:',
      rangeSeparatorText: 'of',
      selectAllRowsItem: true,
      selectAllRowsItemText: 'All',
    },
  };
}
